import { render, staticRenderFns } from "./FileEditorTextOnly.vue?vue&type=template&id=b53b9360&scoped=true&"
import script from "./FileEditorTextOnly.vue?vue&type=script&lang=ts&"
export * from "./FileEditorTextOnly.vue?vue&type=script&lang=ts&"
import style0 from "./FileEditorTextOnly.vue?vue&type=style&index=0&id=b53b9360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b53b9360",
  null
  
)

export default component.exports